import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/designer')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <iframe
      title="Designer"
      style={{ height: '100%', border: 'none' }}
      src="/ll/embedded.html#designer"
    />
  )
}
